import { render, staticRenderFns } from "./traceability.vue?vue&type=template&id=12f6b5da"
import script from "./traceability.vue?vue&type=script&lang=js"
export * from "./traceability.vue?vue&type=script&lang=js"
import style0 from "./traceability.vue?vue&type=style&index=0&id=12f6b5da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports